export default __webpack_public_path__ + "static/media/GeneralBooklet_FR.1732fce4.pdf";